import React from "react"
import { CheckMark } from "../SectionHomepageHero"
import Text from "../Text"
import Box from "../Box"

const SectionColumnPoints = ({ section }: any) => {
  const { listItems } = section

  return (
    <div className="bg-gray-75 p-5 rounded-[20px] shadow-lg max-w-full px-4 lg:max-w-5xl xl:max-w-7xl mx-auto text-center lg:text-left">
      <h2
        className="text-center font-bold fluid-2xl block text-blue-500 mb-8"
        style={{ textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      >
        {section.title}
      </h2>

      <div className="m-4 flex flex-wrap justify-center">
        {listItems.map((item: any, index: any) => (
          <Box
            key={index}
            className="overflow-hidden flex  mb-4 w-full sm:w-1/2"
          >
            <Box className="w-4 h-4 mr-2">
              <CheckMark />
            </Box>
            <Text variant="extra-small" className="text-left">
              {item.title}
            </Text>
          </Box>
        ))}
      </div>
    </div>
  )
}

export default SectionColumnPoints
